export default __webpack_public_path__ + "static/media/spiLogo.87672586.png";